import React from 'react';
import { Line, Pie } from 'react-chartjs-2';
import { BaseURLDev, headers } from '../../_utils/config';
import { Loader, Segment, Label, Select, Grid, Menu, Form } from 'semantic-ui-react';
import { fetchSKPD, fetchOPD, isAdmin, isVerificator } from '../../_utils/localstorage';
import Skeleton from '../../_utils/Skeleton';
import { toIDR } from '../../_utils/tocurrency';

const SKPDFilter = (props) => {

   function childFunc(kode, name){
      props.toChild(kode===10000 ? null: kode, name)
   }

   return (
      <Form>
         <Form.Field 
            placeholder="---Pilih SKPD---"            
            control={Select} 
            search
            loading={props.load}
            disabled={props.load}
            onChange={(e,el)=>childFunc(el.options[el.value].key,el.options[el.value].text)} 
            options={props.data}
            style={{width:'300px'}}
         />
      </Form>
   )
}

const OPDFilter = (props) => {

   function childFunc(kode,name){
      props.toChild(kode===10000?null:kode,name)
   }

   return (
      <Form>
         <Form.Field 
            placeholder="---Pilih OPD---"
            control={Select} 
            search
            loading={props.load}            
            disabled={props.load}            
            onChange={(e,el)=>childFunc(el.options[el.value].key,el.options[el.value].text)} 
            options={props.data}
            style={{width:'300px'}}
         />
      </Form>
   )
}

export default class Statistik extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         
         label : "",
         activeIndex: 0,
         
         skpds:[],
         skpd_kode: null,
         skpd_name: null,

         opds:[],
         opd_kode: null,
         opd_name: null,
         
         dataMonth:[],
         dataToday: null,
         dataFirstToNow: null,
         dataBeforeToNow: null,
         lineChartSKPD: {
            labels: [],
            datasets: [
               {
                  label: "Perencanaan",
                  fill: false,
                  lineTension: 0.3,
                  backgroundColor: "rgba(225,0,0,0.4)",
                  borderColor: "red", // The main line color
                  borderCapStyle: 'square',
                  borderDash: [], // try [5, 15] for instance
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: "black",
                  pointBackgroundColor: "white",
                  pointBorderWidth: 1,
                  pointHoverRadius: 8,
                  pointHoverBackgroundColor: "yellow",
                  pointHoverBorderColor: "brown",
                  pointHoverBorderWidth: 2,
                  pointRadius: 4,
                  pointHitRadius: 10,
                  data: [],
                  spanGaps: true,
               },
               {
                  label: "Realisasi",
                  fill: true,
                  lineTension: 0.3,
                  backgroundColor: "rgba(167,105,0,0.4)",
                  borderColor: "rgb(167, 105, 0)",
                  borderCapStyle: 'butt',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: "white",
                  pointBackgroundColor: "black",
                  pointBorderWidth: 1,
                  pointHoverRadius: 8,
                  pointHoverBackgroundColor: "brown",
                  pointHoverBorderColor: "yellow",
                  pointHoverBorderWidth: 2,
                  pointRadius: 4,
                  pointHitRadius: 10,
                  data: [],
                  spanGaps: false,
                },
            ]
         },
         lineChartMonthBp:{
            labels: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
            datasets: [
               {
                  backgroundColor:"rgba(75,192,192,0.4)",
                  borderCapStyle:"butt",
                  borderColor:"rgba(75,192,192,1)",
                  borderDash:[],
                  borderDashOffset:0,
                  borderJoinStyle:"miter",
                  fill:true,
                  label:"/bulan",
                  lineTension:0.3,
                  pointBackgroundColor:"#fff",
                  pointBorderColor:"rgba(75,192,192,1)",
                  pointBorderWidth:1,
                  pointHitRadius:10,
                  pointHoverBackgroundColor:"rgba(75,192,192,1)",
                  pointHoverBorderColor:"rgba(220,220,220,1)",
                  pointHoverBorderWidth:2,
                  pointHoverRadius:5,
                  pointRadius:1,
                  fillColor: "rgba(220,220,220,0.2)",
                  data:[]
               }
            ]
         },
         lineChartMonthSts:{
            labels: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
            datasets: [
               {
                  label: "STS",
                  fill: false,
                  lineTension: 0.3,
                  backgroundColor: "rgba(225,0,0,0.4)",
                  borderColor: "red", // The main line color
                  borderCapStyle: 'square',
                  borderDash: [], // try [5, 15] for instance
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: "black",
                  pointBackgroundColor: "white",
                  pointBorderWidth: 1,
                  pointHoverRadius: 8,
                  pointHoverBackgroundColor: "#e82e19",
                  pointHoverBorderColor: "#fff",
                  pointHoverBorderWidth: 1,
                  pointRadius: 4,
                  pointHitRadius: 10,
                  data: [],
                  spanGaps: true,
                }, {
                  label: "Realisasi",
                  fill: true,
                  lineTension: 0.3,
                  backgroundColor: "rgba(167,105,0,0.4)",
                  borderColor: "rgb(167, 105, 0)",
                  borderCapStyle: 'butt',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: "white",
                  pointBackgroundColor: "black",
                  pointBorderWidth: 1,
                  pointHoverRadius: 8,
                  pointHoverBackgroundColor: "#a86800",
                  pointHoverBorderColor: "#fff",
                  pointHoverBorderWidth: 1,
                  pointRadius: 4,
                  pointHitRadius: 10,
                  data: [],
                  spanGaps: false,
                }
            ]
         },
         
         pieChartSummary:{
            labels: ['Hari ini','Bulan ini','Januari s/d Bulan lalu','Januari s/d Bulan ini'],
            datasets: [{
               data: [],
               backgroundColor: ['#FF6384','#36A2EB','#FFCE56','#a86800'],
               hoverBackgroundColor: ['#FF6384','#36A2EB','#FFCE56','#a86800']
            }]
         },
         
         requestsBpMonth:true,
         requestsStsMonth:true,
         requestsSummary:true,
         searchRequest:false,
         requestsSKPD:false,
         requestsOPD:false,
      }

      this.filterDataBySKPD = this.filterDataBySKPD.bind(this);
      this.filterDataByOPD = this.filterDataByOPD.bind(this);
      this.resetStatusRequest = this.resetStatusRequest.bind(this);
      this.allData = this.allData.bind(this);

   }

   resetStatusRequest = () => this.setState({searchRequest:true,requestsBpMonth:true,requestsStsMonth:true,requestsSummary:true})

   getDataOPD(){
      fetch(`${BaseURLDev}/simantra/ref/allopd`)
      .then(response => {
         if(!response.ok){
            // messageGagal("Load data SKPD gagal dari SIMDA")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         var { skpd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user: user,
            opd: resJSON.data,
            skpd: skpd
         }))

         const opds = []
         opds.push({'value':0,'text':"Semua Data",'key':10000})
         for(let i=0; i<resJSON.data.length; i++) {
            opds.push({
               'value': i+1,
               'text': `[${resJSON.data[i].kode_opd}] ${resJSON.data[i].opd}`,
               'key': resJSON.data[i].kode_opd,     
            })
         }
         this.setState({opds:opds})
      })
   }

   getDataSKPD(){
      fetch(`${BaseURLDev}/simantra/ref/allskpd`)
      .then(response => {
         if(!response.ok){
            // messageGagal("Load data OPD gagal dari SIMDA")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         var { opd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user:user,
            opd:opd,
            skpd:resJSON.data,
         }))

         const skpds = []
         skpds.push({'value':0,'text':"Semua Data",'key':10000})
         for(let i=0; i<resJSON.data.length; i++) {
            skpds.push({
               'value': i+1,
               'text': `[${resJSON.data[i].kode_skpd}] ${resJSON.data[i].skpd}`,
               'key': resJSON.data[i].kode_skpd,     
            })
         }
         this.setState({skpds:skpds})
      })
   }

   skpdSelect(){
      if(fetchSKPD().length!==0){
         const skpds = []
         skpds.push({'value':0,'text':"Semua Data",'key':10000})
         for(let i=0; i<fetchSKPD().length; i++) {
            skpds.push({
               'value': i+1,
               'text': `[${fetchSKPD()[i].kode_skpd}] ${fetchSKPD()[i].skpd}`,
               'key': fetchSKPD()[i].kode_skpd,     
            })
         }
         this.setState({skpds:skpds})
      }
   }

   opdSelect(){
      if(fetchOPD().length!==0){
         const opds = []
         opds.push({'value':0,'text':"Semua Data",'key':10000})
         for(let i=0; i<fetchOPD().length; i++) {
            opds.push({
               'value': i+1,
               'text': `[${fetchOPD()[i].kode_opd}] ${fetchOPD()[i].opd}`,
               'key': fetchOPD()[i].kode_opd,     
            })
         }
         this.setState({opds:opds})
      }
   }

   getSummary(skpd, opd){
      fetch(`${BaseURLDev}/dashboard/realisasi?skpd=${skpd}&opd=${opd}`, { 
         method: 'GET',
         headers 
      })
      .then(response => response.json())
      .then(res => {
         this.setState({
            pieChartSummary:{
               ...this.state.pieChartSummary,
               datasets:[
                  ...this.state.pieChartSummary.datasets[0],
                  {
                     ...this.state.pieChartSummary.datasets[0],
                     data:[
                           res.data[0],
                           res.data[1],
                           res.data[2],
                           res.data[3]
                     ]
                  }
               ]
            },
            dataSummary:res.data,
            requestsSummary:false
         })
      });
   }

   getStsMonth(skpd,opd){
      fetch(`${BaseURLDev}/statistik/sts/permonth?skpd=${skpd}&opd=${opd}`, { 
         method: 'GET',
         headers 
      })
      .then(response =>response.json())
      .then(res => {
         this.setState({
            lineChartMonthSts:{
               ...this.state.lineChartMonthSts,
               datasets:[
                  ...this.state.lineChartMonthSts.datasets[0],
                  {...this.state.lineChartMonthSts.datasets[0],data:res.unverified},
                  ...this.state.lineChartMonthSts.datasets[1],
                  {...this.state.lineChartMonthSts.datasets[1],data:res.verified}
               ]
            },
            requestsStsMonth:false
         })
      });
   }

   componentWillMount(){
      this.getSummary(null,null);
      this.getStsMonth(null,null);

      if(fetchSKPD().length===0 || fetchOPD().length===0){
         this.getDataSKPD()
         this.getDataOPD()
      }else{
         if(isAdmin() || isVerificator()){
            this.skpdSelect();
            this.opdSelect();
         }
      }
   
   }

   allData(){
      this.resetStatusRequest()
      this.getStsMonth(null,null)
      this.getSummary(null,null)
   }

   filterDataBySKPD(kode, name){
      this.setState({requestsSKPD: true, label: name})
      this.resetStatusRequest()
      this.getStsMonth(kode, null)
      this.getSummary(kode, null)
      this.setState({requestsSKPD: false})      
   }

   filterDataByOPD(kode, name){
      this.setState({requestsOPD: true, label: name})
      this.resetStatusRequest()      
      this.getStsMonth(null, kode)
      this.getSummary(null, kode)
      this.setState({requestsOPD: false})      
   }

   handleClick = (e, titleProps) => {
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
  
      this.setState({ activeIndex: newIndex })
    }

   render() {
      return (
      <div>
            <Grid>   
               {(isAdmin() || isVerificator()) &&
               <Grid.Column width={16}>
                  <Menu>
                     <Menu.Item>
                        <SKPDFilter
                           allData={this.allData}
                           data={this.state.skpds} 
                           disabledBtn={this.state.skpd_kode}
                           toChild={(kode, name)=>this.filterDataBySKPD(kode,name)}
                           load={this.state.requestsSKPD}
                        />
                     </Menu.Item>
                     <Menu.Item>
                        <OPDFilter
                           allData={this.allData}
                           data={this.state.opds} 
                           disabledBtn={this.state.opd_kode}
                           toChild={(kode,name)=>this.filterDataByOPD(kode,name)}
                           load={this.state.requestsOPD}                                 
                        />
                        </Menu.Item>
                     <Menu.Item>
                        <div style={{width:'300px'}}>{this.state.label}</div>
                     </Menu.Item>

                  </Menu>
               </Grid.Column> }           
            <Grid.Column width={8}>
            {this.state.requestsSummary ? <Skeleton /> :
               <Segment padded>
                  <Label attached='top' color="violet">Rincian Realisasi</Label><br />
                  {this.state.requestsSummary ? <Loader active inline='centered' />:
                     <Pie 
                        data={this.state.pieChartSummary} 
                        options={{
                           tooltips: {
                              callbacks: {
                                 title: function(tooltipItem, data) {
                                    return data['labels'][tooltipItem[0]['index']];
                                 },

                                 label: function(tooltipItem, data) {
                                    let nilai = data['datasets'][0]['data'][tooltipItem['index']];
                                    return toIDR(nilai)
                                 },

                                 afterLabel: function(tooltipItem, data) {

                                 }

                              }
                        }
                     }}/>
                  }
               </Segment>
            }
            </Grid.Column>
            <Grid.Column width={8}>
               {this.state.requestsStsMonth ? <Skeleton /> :
                  <Segment padded>
                  <Label attached='top' color="violet">Perbandingan STS dan Realisasi Perbulan</Label><br />
                     {this.state.requestsStsMonth ? <Loader active inline='centered' />
                        : <Line 
                              data={this.state.lineChartMonthSts} 
                              options={{
                                 tooltips: {
                                    callbacks: {
                                       label: function(tooltipItems, data) { 
                                          return toIDR(tooltipItems.yLabel)
                                       }
                                    }
                              },
                              scales: {
                                 yAxes: [{
                                    ticks: {
                                       beginAtZero:true
                                    },
                                    scaleLabel: {
                                          display: true,
                                          labelString: 'Perbandingan STS dan Realisasi',
                                          fontSize: 14
                                       }
                                    }]            
                                 }
                              }}/>
                     }
                  </Segment>
               }
            </Grid.Column>
         </Grid>
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/Statistik.js